module.exports = __webpack_public_path__ + "static/img/thumb1.c5eb5ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing_page/thumbnails/thumb1.jpg
// module id = 642
// module chunks = 0